const gnutilNumBoolOrStrIs = (o, type = typeof o) => (
  type === 'boolean' || type === 'number' || type === 'string')

const gnutilNumOrStrIs = (o, type = typeof o) => (
  type === 'number' || type === 'string')

const gnutilPlainObjIs = ((getproto, objproto = getproto({})) =>
  obj => obj && (getproto(obj) === objproto)
)(Object.getPrototypeOf)

// things like `Date()` or `console` which are not plain 'object'
const gnutilNonNullObjIs = obj =>
  obj && typeof obj === 'object'

const gnutilSpecObjIs = o => gnutilPlainObjIs(o)
  && 'gn:type' in o

const gnutilShallowCp = (value, type = typeof value, f) => {
  if (value === null || gnutilNumBoolOrStrIs(type))
    f = value
  else if (Array.isArray(value))
    f = value.slice()
  else if (type === 'object')
    f = Object.assign({}, value)

  return f
}

const gnutilStringify = (val, mini = false) => {
  if (gnutilNumBoolOrStrIs(val) || val === null)
    return val

  return mini
    ? JSON.stringify(val)
    : `\n${JSON.stringify(val, null, '  ')}`
}

export {
  gnutilNumBoolOrStrIs,
  gnutilNumOrStrIs,
  gnutilPlainObjIs,
  gnutilNonNullObjIs,
  gnutilShallowCp,
  gnutilSpecObjIs,
  gnutilStringify
}
